<template>
  <div class="sapceLeft search-item date-input" @click="chooseSelect">
    <span>{{ label }}:</span>
    <span class="date-show">{{ selectValLabel || "All" }}</span>
    <div class="date-oper">
      <el-select v-model="selectVal" :ref="id" :clearable="false" placeholder="All">
        <el-option v-for="item in options" :value="item.value" :key="item.value">{{item.label}}</el-option>
      </el-select>
    </div>
    <i class="el-icon-circle-close date-close" @click.stop="clearVal()" />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: () => {
        return "label";
      }
    },
    options:{
      type: Array,
      default: () => {
        return [];
      }
    },
    defaultValue:{
      type: [String,Number],
      default: () => {
        return undefined;
      }
    }
  },
  data() {
    return {
      id: "searchDate" + new Date().getTime,
      selectVal: this.defaultValue
    };
  },
  computed:{
    selectValLabel(){
      let item = this.options.find(i => i.value == this.selectVal);
      return item && item.label;
    }
  },
  methods: {
    chooseSelect() {
      this.$refs[this.id].focus();
    },
    clearVal() {
      this.selectVal = undefined;
    }
  },
  watch: {
    selectVal(newVal) {
      this.$emit("valChange", {value: newVal, label: this.selectValLabel});
    }
  }
};
</script>
<style scoped lang="scss">
.date-input {
  position: relative;
  overflow: hidden;
  padding-right: 0.24rem;

  &:hover {
    .date-close {
      visibility: inherit;
    }
  }
  .date-oper {
    width: 100%;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
  }
  .date-show {
    color: #ECECEC;
  }
  .date-close {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -0.09rem;
    visibility: hidden;
  }
  .el-input--medium .el-input__inner {
    border: none;
  }
  .el-date-editor.el-input {
    width: 1.8rem;
  }
}
</style>
